import React from 'react'
import Page from '../components/Page'
import { Spinner, Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import moment from 'moment-timezone'
import Select from 'react-select'
import { Line, Pie, Doughnut, Bar, Radar, Polar } from 'react-chartjs-2'
import { getColor } from '../utils/colors'
import { randomNum } from '../utils/demos'
import { IconWidget, NumberWidget, Text2Widget } from '../components/Widget'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'

const tbcolumn = [
  {
    label: 'Product No',
    field: 'product_no',
    sort: 'asc',
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },
  {
    label: 'Category',
    field: 'category',
    sort: 'asc',
  },
  {
    label: 'Page View',
    field: 'pageview',
    sort: 'asc',
  },
  {
    label: 'Item Sold',
    field: 'sold',
    sort: 'asc',
  },
]

class PosAnalyticPage extends React.Component {
  _isMounted = true
  posanalyticpage = StorageService.getSession('posanalyticpage')
  comp = StorageService.getSession('selected_org')
  constructor() {
    super()
    this.state = {
      Role: this.comp.Role,
      redirect: false,
      isLoading: false,
      storeList: [],
      tagList: [],
      tags: 'All',
      store_id: '',
      fm_date: this.posanalyticpage && this.posanalyticpage.fm_date ? this.posanalyticpage.fm_date : moment().subtract(7, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      to_date: this.posanalyticpage && this.posanalyticpage.to_date ? this.posanalyticpage.to_date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      analyticData: [],
      login_registered: 0,
      total_session: 0,
      made_order: 0,
      average_order: 0,
      average_register: 0,
      total_sales: 0,
      average_sales: 0,
      product: [],
      device_unknown: 0,
      device_desktop: 0,
      device_mobile: 0,
      user_returning: 0,
      user_new: 0,
    }
  }

  componentDidMount() {
    this.getStoreList()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getStoreList() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          let storeList = []
          for (let i of access.store) {
            for (let j of result.data) {
              if (j.store_id === i.store_id) {
                if (i.role == 'Admin' || i.role == 'Supervisor' || i.role == 'Financial' || i.role == 'Manager' || i.role == 'Superuser') {
                  storeList.push(j)
                }
              }
            }
          }
          let store_id = this.posanalyticpage && this.posanalyticpage.store_id ? this.posanalyticpage.store_id : storeList.length ? storeList[0].store_id : ''
          this.setState({
            storeList: storeList,
            store_id: store_id,
          })
          console.log(store_id)
          if (store_id != '') {
            this.getTag()
          }
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getTag(store_id = null, reload = false) {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: store_id == null ? this.state.store_id : store_id,
    }

    axios
      .post(url + ':3005/v1/analytics/tag', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            tagList: result.data,
            tags: 'All',
          })
          if (reload) {
            this.getAnalytic()
          }
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  storeHandler = e => {
    const { label, value } = e
    this.setState({
      store_id: value,
    })
    let data = this.posanalyticpage ? this.posanalyticpage : {}
    data['store_id'] = value
    StorageService.setSession('posanalyticpage', data)
    this.paymentDetail = StorageService.getSession('posanalyticpage')
    this.getTag(value, false)
  }

  dateHandler = e => {
    const { name, value } = e.target
    if (name == 'fm_date') {
      let start_date = moment('2021-07-01').tz('Asia/Singapore').format('YYYY-MM-DD')
      let cur_date = moment(value).tz('Asia/Singapore').format('YYYY-MM-DD')
      if (cur_date < start_date) {
        alert('Cannot be earlier than 1 July 2021')
        return
      }
    }

    if (name == 'to_date') {
      let today = moment().tz('Asia/Singapore').format('YYYY-MM-DD')
      let cur_date = moment(value).tz('Asia/Singapore').format('YYYY-MM-DD')
      if (cur_date > today) {
        alert('Cannot be later than today')
        return
      }
    }

    this.setState({
      [name]: value,
    })
    let data = this.posanalyticpage ? this.posanalyticpage : {}
    data[name] = value
    StorageService.setSession('posanalyticpage', data)
    this.posanalyticpage = StorageService.getSession('posanalyticpage')
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.posanalyticpage ? this.posanalyticpage : {}
    data[name] = value
    StorageService.setSession('posanalyticpage', data)
    this.posanalyticpage = StorageService.getSession('posanalyticpage')
  }

  getAnalytic() {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      tag: this.state.tags,
    }

    axios
      .post(url + ':3005/v1/analytics/session/daily', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            login_registered: result.data.login_registered,
            total_session: result.data.total_session,
            made_order: result.data.made_order,
            average_order: result.data.average_order,
            average_register: result.data.average_register,
            total_sales: result.data.total_sales,
            analyticData: result.data.data,
            average_sales: result.data.average_sales,
            product: result.data.product,
            device_unknown: result.data.device_unknown,
            device_desktop: result.data.device_desktop,
            device_mobile: result.data.device_mobile,
            user_returning: result.data.user_returning,
            user_new: result.data.user_new,
            isLoading: false,
          })
        }
      })
      .catch(error => {
        this.setState({ isLoading: false })
        alert(error)
      })
  }

  render() {
    let { analyticData, Role, storeList } = this.state
    let options = [
      ...this.state.storeList
        .reduce((r, o) => {
          let key = o.store_id
          let item = { value: o.store_id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]

    let option = {
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    }

    let date = []
    let web_session = []
    let new_registered = []
    let login_session = []
    let made_order = []

    if (analyticData.length > 0) {
      for (let i of analyticData) {
        date.push(i.date)
        web_session.push(i.session)
        new_registered.push(i.register)
        login_session.push(i.login)
        made_order.push(i.ordered)
      }
    }

    const genLineData = () => {
      return {
        labels: date,
        datasets: [
          {
            label: 'Web Session',
            backgroundColor: getColor('primary'),
            borderColor: getColor('primary'),
            borderWidth: 1,
            data: web_session,
            fill: false,
          },
          {
            label: 'New Registered',
            backgroundColor: getColor('secondary'),
            borderColor: getColor('secondary'),
            borderWidth: 1,
            data: new_registered,
            fill: false,
          },
          {
            label: 'Login Session',
            backgroundColor: getColor('warning'),
            borderColor: getColor('warning'),
            borderWidth: 1,
            data: login_session,
            fill: false,
          },
          {
            label: 'Made Order',
            backgroundColor: getColor('default_secondary'),
            borderColor: getColor('default_secondary'),
            borderWidth: 1,
            data: made_order,
            fill: false,
          },
        ],
      }
    }

    const PlatformPieData = () => {
      return {
        datasets: [
          {
            data: [this.state.device_mobile, this.state.device_desktop, this.state.device_unknown],
            backgroundColor: [getColor('primary'), getColor('secondary'), getColor('warning')],
            label: 'Platform',
          },
        ],
        labels: ['Mobile', 'Desktop', 'Unknown'],
      }
    }

    const UserTypePieData = () => {
      return {
        datasets: [
          {
            data: [this.state.user_returning, this.state.user_new],
            backgroundColor: [getColor('primary'), getColor('secondary')],
            label: 'User Type',
          },
        ],
        labels: ['Returning', 'New'],
      }
    }

    const data = {
      columns: tbcolumn,
      rows: this.state.product,
    }

    return (
      <Page className="PosAnalyticPage" title="Analytic Overview" breadcrumbs={[{ name: 'Analytics', active: true, path: '/posanalytic' }]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        {(Role === 'Superuser' || Role === 'Admin' || Role === 'Supervisor' || Role === 'Manager' || Role === 'Financial' || storeList.length > 0) && (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={3}>
                      <Label>Store</Label>
                      <Select options={options} value={options.filter(i => i.value == this.state.store_id)} name="store_id" onChange={this.storeHandler} menuPosition={'fixed'} required />
                    </Col>
                    <Col md={2}>
                      <Label>Start Date</Label>
                      <Input className="ps-input-small" type="date" name="fm_date" onChange={this.dateHandler} value={this.state.fm_date} />
                    </Col>
                    <Col md={2}>
                      <Label>End Date</Label>
                      <Input className="ps-input-small" type="date" name="to_date" onChange={this.dateHandler} value={this.state.to_date} />
                    </Col>
                    <Col md={2}>
                      <Label>Tags</Label>
                      <Input className="ps-input-small" type="select" name="tags" value={this.state.tags} onChange={this.changeHandler}>
                        {this.state.tagList.map((item, index) => {
                          return (
                            <option key={index} value={item.tag}>
                              {item.tag}
                            </option>
                          )
                        })}
                      </Input>
                    </Col>
                    <Col md={2} className="ps-margin-auto-desktop">
                      <Button className="ps-input-small" onClick={() => this.getAnalytic()}>
                        Apply
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <Card>
                        <CardBody>
                          <Line data={genLineData()} options={option} height={400} width={500} />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <NumberWidget
                        title="Login/Registered"
                        number={this.state.login_registered}
                        color="primary"
                        progress_color="default_secondary"
                        progress={{
                          value: this.state.login_registered,
                          label: 'Total Sessions',
                          max: this.state.total_session,
                          count: this.state.total_session,
                        }}
                      />
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <NumberWidget
                        title="Made Order"
                        number={this.state.made_order}
                        color="primary"
                        progress_color="default_secondary"
                        progress={{
                          value: this.state.made_order,
                          label: 'Login/Registered',
                          max: this.state.login_registered,
                          count: this.state.login_registered,
                        }}
                      />
                    </Col>
                    <Col lg={2} md={6} sm={6} xs={12}>
                      <Text2Widget title="Average Order Duration" text={this.state.average_order + ' mins'} color="black" />
                    </Col>
                    <Col lg={2} md={6} sm={6} xs={12}>
                      <Text2Widget title="Average Register Duration" text={this.state.average_register + ' mins'} color="black" />
                    </Col>
                    <Col lg={2} md={6} sm={6} xs={12}>
                      <Text2Widget title="Total Sales" text={'$' + this.state.total_sales} color="red" text2={this.state.average_sales} />
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={8} lg={12} md={8}>
                      <Card>
                        <CardBody>
                          <MDBDataTableV5 className="ps-order-table th-5" data={data} displayEntries={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xl={4} lg={12} md={4}>
                      <Row>
                        <Col>
                          <Card>
                            <CardHeader>PlatForm</CardHeader>
                            <CardBody>
                              <Pie data={PlatformPieData()} />
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Card>
                            <CardHeader>User Type</CardHeader>
                            <CardBody>
                              <Pie data={UserTypePieData()} />
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Page>
    )
  }
}

export default PosAnalyticPage
